<div *ngIf="loading">Lade...</div>
<san-stepper
  #stepperComponent
  (leftButtonClicked)="leftButtonClicked($event)"
  (pageChanged)="calculateValidity()"
  (rightButtonClicked)="rightButtonClicked($event)"
  [hideBottomButtons]="false"
  [leftButtonDisabled]="leftButtonDisabled"
  [leftButtonText]="leftButtonText"
  [rightButtonDisabled]="rightButtonDisabled"
  [rightButtonText]="rightButtonText"
  [showSteps]="false"
>
  <san-step>
    <p>Sehr geehrte{{ anrede }},</p>
    <p>
      wir haben unsere
      <a [href]="environment.nutzungsbedingungen" target="_blank">
        Nutzungsbedingungen
      </a>
      und
      <a [href]="environment.nutzungsbedingungen" target="_blank">
        Datenschutzbestimmungen
      </a>
      aktualisiert.
    </p>
    <p>
      Bitte stimmen Sie diesen zu, bevor Sie das Sanakey-Portal weiter nutzen.
    </p>
    <p>Vielen Dank!</p>
    <div>
      <label>
        <input
          [(ngModel)]="nutzungAkzeptiert"
          (ngModelChange)="calculateValidity()"
          type="checkbox"
        />
        Ich stimme den
        <a [href]="environment.nutzungsbedingungen" target="_blank"
        >Nutzungsbedingungen</a
        >
        zu.
      </label>
    </div>
    <div>
      <label>
        <input
          [(ngModel)]="datenschutzAkzeptiert"
          (ngModelChange)="calculateValidity()"
          type="checkbox"
        />
        Ich stimme den
        <a [href]="environment.datenschutzbestimmungen" target="_blank"
        >Datenschutzbestimmungen</a
        >
        zu.
      </label>
    </div>
    <div>
      Für Rückfragen stehen wir gern zur Verfügung:
      <a href="mailto:service@sanakey-portal.de"
      >service&#64;sanakey-portal.de</a
      >
    </div>
  </san-step>
  <san-step>
    <h4>Achtung:</h4>
    <p>
      Wenn Sie die Datenschutz- und Nutzungsbedingungen nicht akzeptieren,
      können Sie das Sanakey-Portal leider nicht weiter nutzen. Bei Fragen
      wenden Sie sich bitte an service&#64;sanakey-portal.de.
    </p>
  </san-step>
</san-stepper>
